import {getToken,getAccessToken,reqDrawInit} from "@/api/index";
const isLogin = false;
const config = {
    AppID: "wx24281b1290fe01a1", //河北新闻网官方
}

// 判断是否微信浏览器  授权登录
function isWeixin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
};

// function wxGetAccessToken() {
//     const CODE = GetQueryString("code");
//     const STATE = GetQueryString("state");
//     console.log('CODE',CODE);
//     console.log('STATE',STATE);
//     if (STATE !== null) { // 此页面为微信重定向过来且用户允许授权      
//       if (CODE === null) {
//         clearCookie('wxToken');
//         console.log('CODE NULL');
//       } else {
//         let params = {
//           "code": CODE,
//         };
//         //获取access_token
//         getAccessToken(params).then(res => {
//             console.log('res',res);
//           if (res.flag == 'success') {
//             console.log('getAccessToken success');
//             let accessInfo = res.data;            
//             setCookie('openId', tokenInfo.openid, 7)
//             setCookie('wxToken', tokenInfo.access_token, 7)
//           } else {
//             toast('授权失败', 2000);
//           }
//         })
//       }
//     }else{
//         console.log('STATE NULL');
//     }  
//   };

  function wxAuthorize() {
    if (isWeixin()) {     
        const origin_state = Math.floor(Math.random() * 1000000);
        const SCOPE = "snsapi_userinfo";
        let currentURL = removeQueryParam(window.location.href, "code"); //去除url携带的code，以免与微信回调中code重复
        currentURL = removeQueryParam(currentURL, "state"); //去除url携带的state，以免与微信回调中state重复
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.AppID + '&response_type=code&scope=' + SCOPE + '&state=' + origin_state + '&redirect_uri=' + encodeURIComponent(currentURL) + '#wechat_redirect';
    } else {
        // toast('请在微信中打开', 2000);
        console.log('请在微信中打开');
    }
  };
  
  //去除url中参数（key value）
  function removeQueryParam(url, key) {
    // 使用正则表达式匹配参数
    const pattern = new RegExp(`[?&]${encodeURIComponent(key)}=([^&]*)`);
    const match = url.match(pattern);
    if (!match) {
      return url; // 如果没有匹配到，直接返回原URL
    } 
    const newUrl = url.replace(pattern, ''); // 删除匹配到的参数和其值    
    if (newUrl[0] === '?') {
      return newUrl.substring(1); // 如果新URL的查询字符串以'?'开头，去掉它
    }   
    return newUrl;
  }
  
  //设置cookie
  function setCookie(cname, cvalue, exday) {
    var d = new Date();
    d.setTime(d.getTime() + (exday *24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  };
  
  // cookie
  function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
    // document.cookie="cityId=" + this.cityId+ ";expires=" + exp.toGMTString();
  };
  
  //清除cookie
  function clearCookie(name) {
    setCookie(name, "", -1);
  };
  
  function GetQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return r
  };
  
  function toast(msg, duration) {
    duration = isNaN(duration) ? 3000 : duration;
    var m = document.createElement('div');
    m.innerHTML = msg;
    m.style.cssText = "max-width:80%;min-width: 150px;padding:5px 14px;min-height: 22px;color: rgb(255, 255, 255);line-height: 22px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 14px;";
    document.body.appendChild(m);
    setTimeout(function () {
      var d = 0.5;
      m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
      m.style.opacity = '0';
      setTimeout(function () {
        document.body.removeChild(m)
      }, d * 1000);
    }, duration);
  };
  export {wxAuthorize, isWeixin, getCookie,toast, removeQueryParam}
  